import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

// 👇 NUEVO: proveedor de claims/rol
import { ClaimsProvider } from './providers/ClaimsProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* 👇 Envuelve la app para refrescar token y exponer role/claims */}
    <ClaimsProvider>
      <App />
    </ClaimsProvider>
  </React.StrictMode>
);

// PWA
// ❌ NO
// serviceWorkerRegistration.register();

// ✅ SÍ
serviceWorkerRegistration.unregister();
reportWebVitals();